import { neutralizeStyleBreakout } from '../common/css-safe'

export default function Stylesheet({ css }: { css: string | string[] }) {
    const joined = Array.isArray(css) ? css.filter(Boolean).join('') : css
    return (
      <style
        // #904: last-line breakout guard. Emission-time validation neutralizes
        // the color/font tokens, but customCss is deliberately raw — so also
        // neutralize `</style` on the full string reaching this sink, which no
        // valid stylesheet needs. Covers every widget that renders CSS here.
        dangerouslySetInnerHTML={{
          __html: neutralizeStyleBreakout(joined),
        }}
      />
    )
  }

